import { render, staticRenderFns } from "./allotManagement.vue?vue&type=template&id=76c0357e&"
import script from "./allotManagement.vue?vue&type=script&lang=js&"
export * from "./allotManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports